import * as React from "react";
import {
  Grid,
  Typography,
  Snackbar,
  IconButton,
  withStyles,
  Tabs,
  Tab,
  Tooltip,
} from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";
import ModalLinkCredencial from "modules/profile/components/layouts/ModalLinkCredencial";
import { ProfileStore } from "modules/profile/ProfileStore";
import { LoginStore } from "modules/login/LoginStore";
import i18n from "i18n";
import { observer } from "mobx-react";
import InputSearch from "common/components/fields/InputSearch";
import Profile from "./Profile";
import Users from "./Users";
import Company from "./Company";
import Padlock from "common/icons/Padlock";
import SubscribeNowCard from "modules/development/components/layouts/SubscribeNowCard";

const styles = (theme) => ({
  root: {
    width: "100%",
  },

  table: {
    width: "800px",
    backgroundColor: "white",
  },

  container: {
    left: 0,
    top: 0,
    zIndex: 2,
    display: "grid",
    gridTemplateRows: "auto 1fr",
    height: "calc(100vh - 64px)",
    backgroundColor: theme.palette.secondary.main,
    overflow: "auto",
  },

  companyNameInput: {
    width: "526px",
    marginBottom: "25px",
    left: "426px",
  },

  header: {
    backgroundColor: theme.palette.secondary.light,
    borderBottom: "1px solid #dedede",
    height: "64px",
  },
  title: {
    lineHeight: "64px",
    fontSize: "16px",
    fontFamily: "Roboto",
    fontWeight: 700,
  },
  gridContent: {
    marginTop: "65px",
    display: "grid",
    gridTemplateColumns: "90px 1fr",
    gridColumnGap: "45px",
    maxWidth: "800px",
    margin: "0 auto",
  },

  textFieldRoot: {
    width: "100%",
    marginBottom: "25px",
  },

  formHelperTextError: {
    fontFamily: "Roboto",
    color: "#9E0000",
    fontSize: "12px",
    fontWeight: 500,
  },
  formHelperLink: {
    cursor: "pointer",
    textDecoration: "underline",
  },
  unverifiedIcon: {
    transform: "rotate(45deg)",
    fontSize: 22,
    color: "#9E0000",
  },
  checkIcon: {
    fontSize: 22,
    color: "#6B7A00",
  },
  lockIcon: {
    fontSize: 20,
    color: "rgba(0, 0, 0, 0.38)",
  },
  actions: {
    marginTop: "20px",
    marginBottom: "37px",
    display: "flow-root",
  },
  accountButton: {
    margin: "8px 0px",
  },
  textFieldInput: {
    fontFamily: "Roboto",
    fontSize: "18px",
    fontWeight: 400,
  },
  cancel: {
    marginRight: "15px",
    float: "right" as any,
  },
  message: {
    "& > :first-child > :first-child": {
      maxWidth: "calc(100% - 64px)",
    },
  },
  tabsRoot: {
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.secondary.dark,
    boxShadow: "unset",
    width: "fit-content",
    fontSize: "12px",
  },
  tabsIndicator: {
    height: 0,
  },
  tabRoot: {
    padding: `0px ${theme.spacing.unit * 2}px`,
    minWidth: "unset",
    border: "unset",
    fontWeight: 500,
    "&$tabSelected > :first-child": {
      borderBottom: `3px solid ${theme.palette.primary.light}`,
      fontWeight: 700,
    },
    "&:hover": {
      color: theme.palette.primary.light,
    },
    transition: "all 0.3s ease-in",
  },
  tabSelected: {
    color: theme.palette.primary.light,
  },
  tabLabelContainer: {
    padding: "0px",
  },
  tabWrapper: {
    height: "63px",
    display: "block",
    lineHeight: "63px",
    fontFamily: "Raleway",
  },
  tabIconContainer: {
    minHeight: "unset",
  },
  tabIcon: {
    fontSize: "0.875rem",
    marginRight: "0.6rem",
  },

  blockContributors: {
    width: "950px",
    marginBottom: "15%",
    display: "flex",
    justifyContent: "space-between",
  },
  gridSearch: {
    display: "table",
    height: "100%",
    "& > :first-child": {
      display: "table-cell",
      height: "100%",
      verticalAlign: "middle",
    },
  },
  topBtn: {
    color: "#FFF",
    backgroundColor: "#9AAF00",
    marginLeft: "15px",
    marginRight: "15px",
    "&:hover": {
      backgroundColor: "#7E8F00",
    },
  },
});

type IProps = {
  classes: any;
};

@observer
class Settings extends React.Component<IProps> {
  state = {
    currentTab: 0,
    companyName: ProfileStore.companyName != "" ? ProfileStore.companyName : "",
    searchUser: [],
  };

  componentDidMount() {
    document.title = `Rubk - ${i18n.menu.account.view}`;
    setTimeout(() => {
      if (this.state.companyName != "") {
        ProfileStore.companyInfos = true;
      }
    }, 500);
  }

  componentWillUnmount() {
    document.title = "Rubk";
    ProfileStore.resetStore();
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  componentWillMount = () => {
    ProfileStore.setProviders();
  };

  handleTabsChange = (event, value) => {
    if (!LoginStore.isTrialUser()) {
      ProfileStore.currentTab = value;
      this.setState({ currentTab: value });
    }
  };

  killEvent = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  handleCloseSnackbar = () => (ProfileStore.openSnackbar = false);

  handleInputChange = async (value) => {
    ProfileStore.search = value.toLowerCase();

    if (value == "operador" || value == "administrador") {
      const valueToCompare = value == "administrador" ? 0 : 1;
      ProfileStore.usersSearch = ProfileStore.users.filter(
        (user) => user.data.access === valueToCompare
      );
    } else {
      ProfileStore.usersSearch = ProfileStore.users.filter((user) => {
        const userName = user.data.displayName.toLowerCase();
        const userEmail = user.data.email.toLowerCase();

        return (
          userName.includes(ProfileStore.search) ||
          userEmail.includes(ProfileStore.search)
        );
      });
    }

    ProfileStore.usersView = ProfileStore.usersSearch;
  };

  handleCleanFilter = () => {
    ProfileStore.search = "";
    ProfileStore.usersView = ProfileStore.users;
  };

  render() {
    const { classes } = this.props,
      { currentTab } = this.state,
      displayName = LoginStore.userAuth ? LoginStore.userAuth.displayName : "",
      { password, message, openSnackbar } = ProfileStore,
      tabClasses = {
        root: classes.tabRoot,
        selected: classes.tabSelected,
        labelContainer: classes.tabLabelContainer,
        wrapper: classes.tabWrapper,
        labelIcon: classes.tabIconContainer,
      };

    const isTrial = LoginStore.isTrialUser();
    const icon = isTrial ? <Padlock className={classes.tabIcon} /> : undefined;

    return (
      <React.Fragment>
        <SubscribeNowCard />
        <Grid container item xs={12} className={classes.header}>
          <Grid item xs={2} style={{ textAlign: "center" }}>
            <Typography className={classes.title}>{displayName}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Tabs
              value={currentTab}
              onChange={this.handleTabsChange}
              classes={{
                root: classes.tabsRoot,
                indicator: classes.tabsIndicator,
              }}
            >
              {/* <Tab classes={tabClasses} label={i18n.profile.tab.myProfile} /> */}
              {isTrial ? (
                <Tooltip title={i18n.trialMessage.functionalityNotAvailable}>
                  <Tab
                    classes={tabClasses}
                    icon={icon}
                    label={i18n.profile.tab.company}
                  />
                </Tooltip>
              ) : (
                <Tab classes={tabClasses} label={i18n.profile.tab.myProfile} />
              )}
              {isTrial ? (
                <Tooltip title={i18n.trialMessage.functionalityNotAvailable}>
                  <Tab
                    classes={tabClasses}
                    icon={icon}
                    label={i18n.profile.tab.company}
                  />
                </Tooltip>
              ) : (
                <Tab
                  classes={tabClasses}
                  icon={icon}
                  label={i18n.profile.tab.company}
                />
              )}
              {isTrial ? (
                <Tooltip title={i18n.trialMessage.functionalityNotAvailable}>
                  <Tab
                    classes={tabClasses}
                    icon={icon}
                    label={i18n.profile.tab.contributors}
                  />
                </Tooltip>
              ) : (
                <Tab
                  classes={tabClasses}
                  icon={icon}
                  label={i18n.profile.tab.contributors}
                />
              )}
            </Tabs>
          </Grid>
          <Grid item xs={4} className={classes.gridSearch}>
            <div>
              {ProfileStore.currentTab == 2 && (
                <InputSearch
                  disabled={false}
                  placeholder={i18n.developments.header.search}
                  handleChange={this.handleInputChange}
                  handleClean={this.handleCleanFilter}
                />
              )}
            </div>
          </Grid>
        </Grid>

        {ProfileStore.currentTab == 0 ? (
          <Profile classes={classes} password={password} />
        ) : ProfileStore.currentTab == 1 ? (
          <Company classes={classes} />
        ) : ProfileStore.currentTab == 2 ? (
          <Users classes={classes} searchUser={this.state.searchUser} />
        ) : (
          ""
        )}

        {!password && <ModalLinkCredencial />}
        <Snackbar
          message={message}
          open={openSnackbar}
          autoHideDuration={6000}
          classes={{ root: classes.message }}
          onClose={this.handleCloseSnackbar}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          action={
            <IconButton color="inherit" onClick={this.handleCloseSnackbar}>
              <CloseIcon />
            </IconButton>
          }
        />
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(Settings);



// WEBPACK FOOTER //
// ./src/modules/profile/components/pages/Settings.tsx